import type { IVersionedLine } from '../../../../models/versioned-line.model';
import { LineApiModel } from './line.api-model';

export class VersionedLineApiModel {
  public gid!: string;
  public technicalLineNumber!: string;
  public versions!: LineApiModel[];

  public static mapToBusinessModel(apiModel: VersionedLineApiModel): IVersionedLine {
    return {
      gid: apiModel.gid,
      technicalLineNumber: apiModel.technicalLineNumber,
      versions: apiModel.versions.map((v) => LineApiModel.mapToBusinessModel(v)),
    };
  }
}
